import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { merge, cloneDeep } from 'lodash';
import style from './style.vue';
import { PolicyTypeText, PolicyPatternText, PolicyType, PolicyPattern } from './newDistributionList';
import specialProConfig from './specialProConfig';
import { IPSService } from '@/services/ipsServices';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
import { noop, showPlatform } from '@/util';
import Upload from '@/views/components/upload/upload.vue';
import miniPageLink from '@/views/components/linkForm/miniPage';

enum RequestType {
  DEPOSIT = 1, // 缴纳佣金
  FULL_AMOUNT, // 消费门槛
  NOT_REQUIRED, // 无要求
  CORP_GUIDE, // 集团导购
  SITE_GIDE, // 本店导购
  EMP, // 员工
  BUYER_LEVEL, // 会员等级
}

const RequestTypeList = [
  { label: RequestType.DEPOSIT, text: '缴纳押金', info: '' },
  { label: RequestType.FULL_AMOUNT, text: '消费门槛', info: '' },
  { label: RequestType.NOT_REQUIRED, text: '无要求', info: '' },
  {
    label: RequestType.CORP_GUIDE,
    text: '集团导购',
    info: '当前云店为商城模式时，只要在集团为导购身份则可成为导购分销员',
  },
  { label: RequestType.SITE_GIDE, text: '本店导购', info: '' },
  { label: RequestType.EMP, text: '员工身份', info: '需为本集团员工，方可申请成为员工分销员' },
  { label: RequestType.BUYER_LEVEL, text: '会员等级', info: '' },
];

// const OtherConfigList = [
//   { text: '需上传身份证', key: 'uploadIDCard' },
//   { text: '需填写申请理由', key: 'needReason' },
//   { text: '需填写地址', key: 'needAddress' },
//   { text: '需填写银行卡信息', key: 'uploadBankCard' },
//   { text: '需后台管理员审核身份', key: 'needReview' },
// ];

const SettlementCycle = [
  { label: '付款', value: 1 },
  { label: '发货', value: 2 },
  { label: '收货', value: 3 },
];
interface NewDistrubutionInfo {
  policyId?: number;
  policyName?: string;
  tagName?: string;
  policyType?: 0 | 1 | 2;
  policyPattern?: 0 | 1;
  requestConfig?: {
    requestType?: 1 | 2 | 7;
    deposit?: number;
    consumeDay?: number;
    money?: number;
    allowLevel?: Array<number>;
    returnDay?: number;
    linkNoLimit?: number;
    tips?: string;
  };
  otherConfig?: {
    uploadIDCard?: number | boolean;
    watermarkText?: string;
    needReason?: number | boolean;
    needAddress?: number | boolean;
    uploadBankCard?: number | boolean;
    needReview?: number | boolean;
  };
  rulePage?: number | string;
  contentPage?: number | string;
  rulePageName?: string;
  contentPageName?: string;
  commissionConfig?: {
    type?: number;
    profitTime?: number;
    list?: {
      minPercent?: number;
      maxPercent?: number;
      distributionPercent?: number;
    }[];
    countType?: number;
    countTime?: number;
    classConfig?: {
      classCode?: string;
      classPerCent?: number;
    }[];
    tips?: string;
  };
  profitOutConfig?: {
    limitBalance?: number;
    timeConfig?: {
      type?: number;
      outCount?: number;
    };
    maxBalance?: number;
    checkBankCard?: number | boolean;
    outType?: number;
    outTitle?: string;
    outNote?: string;
  };
  sitePolicy?: number;
  isOpenSecond?: number | boolean;
  secondGuiderConfig?: {
    secondMaxPerson?: number;
    secondBalanceConfig?: {
      type?: number;
      secondProportion?: number;
    };
    secondValidityPeriodDay?: number;
    sharePosterConfig?: {
      imageUrl?: string;
      title?: string;
      desc?: string;
    };
    shareCardConfig?: {
      imageUrl?: string;
      title?: string;
    };
  };
}
@Component({
  mixins: [style],
  components: {},
})
export default class NewDistrubutionEdit extends Vue {
  @Prop({ default: false })
  disabled: boolean;

  @Prop()
  policyId: number;

  // 策略类型
  policyType: number;

  // 佣金模式
  policyPattern: number;

  @Prop()
  sgId: number;

  @Prop()
  modeType: number;

  @Prop()
  empCode;

  @Prop()
  policyState: number;

  // 最大佣金比例
  @Prop({ default: 0 })
  maxCommission: number;

  $refs: {
    form: ElForm;
  };

  baseData: NewDistrubutionInfo = {
    policyId: 1,
    policyName: '',
    tagName: '',
    policyType: 0,
    policyPattern: 0,
    requestConfig: {
      requestType: 1,
      deposit: 1,
      consumeDay: 1,
      money: 1,
      allowLevel: [],
      returnDay: 1,
      linkNoLimit: 1,
      tips: '',
    },
    otherConfig: {
      uploadIDCard: 0,
      watermarkText: '',
      needReason: 0,
      uploadBankCard: 0,
      needAddress: 0,
      needReview: 0,
    },
    rulePage: '',
    rulePageName: '',
    // contentPage: "",
    // contentPageName: "",
    commissionConfig: {
      type: 1,
      profitTime: 1,
      list: [
        {
          minPercent: 30,
          maxPercent: 100,
          distributionPercent: 0.01,
        },
      ],
      countType: 1,
      countTime: 1,
      classConfig: [],
      tips: '',
    },
    profitOutConfig: {
      limitBalance: 1,
      timeConfig: {
        type: 1,
        outCount: 1,
      },
      maxBalance: 1,
      checkBankCard: 1,
      outNote: '',
      outType: 1,
      outTitle: '',
    },
    sitePolicy: 1,
    isOpenSecond: 1,
    secondGuiderConfig: {
      secondMaxPerson: 0,
      secondBalanceConfig: {
        type: 2,
        secondProportion: 0,
      },
      secondValidityPeriodDay: 0,
      sharePosterConfig: {
        imageUrl: '',
        title: '',
        desc: '',
      },
      shareCardConfig: {
        imageUrl: '',
        title: '',
      },
    },
  };

  // 策略配置数据
  data: NewDistrubutionInfo = this.baseData;

  // 特殊商品佣金配置
  specialProductConfig = 0;

  // 开启到店小程序下单不算佣金
  openSitePolicy = false;

  // 新老门户,1老2新

  isNewEmp = 0;

  // 用户等级

  buyerLevel = [];

  // 申请前提身份可选项
  applyList = [];

  isShowNeedBank = false

  public rules = {
    'policyName': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'tagName': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    // 杭俊雅说 其他条件不必填
    'otherConfig': [{ required: false, validator: this.otherConfigValidate, trigger: 'change' }],
    'requestConfig.deposit': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'requestConfig.consumeDay': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'requestConfig.money': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'requestConfig.allowLevel': [{ required: true, message: '请选择会员等级', trigger: ['blur', 'change'] }],
    'requestConfig.returnDay': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'commissionConfig.countTime': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'profitOutConfig.limitBalance': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'profitOutConfig.timeConfig.outCount': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    
    'profitOutConfig.maxBalance': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    'profitOutConfig.outNote': [{ required: true, message: ' ', trigger: 'change' }],
    'profitOutConfig.outTitle': [{ required: true, message: ' ', trigger: 'change' }],
    'rulePage': [{ required: true, message: '请选择规则介绍', trigger: 'change' }],
    'secondGuiderConfig.secondBalanceConfig.secondProportion': [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
    // "contentPage": [{ required: true, message: "请选择用户协议", trigger: "change" }],
  };

  mounted() {
    this.isNewEmp = +localStorage.getItem('platformVersion');
    this.getData();
    const list = ['embryform', 'devtest2', 'really'];
    this.isShowNeedBank = showPlatform(list)
  }

  async getData() {
    this.getSpecialProList();
    IPSService.buyerLevel({
      postParams: {
        sgId: this.sgId,
      },
    }).then((res) => {
      this.buyerLevel = res.list;
    });
    IPSService.newDistributionDetail({
      postParams: {
        policyId: this.policyId,
      },
    }).then((response) => {
      if (response.isOpenSecond) {
        if (!response.secondGuiderConfig.secondBalanceConfig) {
          this.$set(response.secondGuiderConfig, 'secondBalanceConfig', { type: 1, secondProportion: response.secondGuiderConfig.secondCommissionProportion / 100 });
        } else {
          response.secondGuiderConfig.secondBalanceConfig.secondProportion /= 100
        }
      }

      // response.isOpenSecond && response.secondGuiderConfig.secondBalanceConfig && (response.secondGuiderConfig.secondBalanceConfig.secondProportion /= 100);
      (this.data as ItemObject) = cloneDeep(merge(this.baseData, response));
      this.policyType = this.data.policyType;
      this.policyPattern = this.data.policyPattern;
      // 本期佣金和业绩模式各只有一个选项 默认选择
      this.policyPattern === PolicyPattern.achievement && (this.data.commissionConfig.type = 2);
      this.policyPattern === PolicyPattern.commission && (this.data.commissionConfig.type = 1);

      // this.data.contentPage ?  this.getPageName(this.data.contentPage, "contentPageName") : (this.data.contentPage = "");
      this.data.rulePage ? this.getPageName(this.data.rulePage, 'rulePageName') : (this.data.rulePage = '');
      // 当分销类型为顾客分销时 申请前提为 缴纳押金 消费门槛 会员等级 无要求
      if (this.policyType === PolicyType.customer) {
        this.applyList = [RequestTypeList[0], RequestTypeList[1], RequestTypeList[6], RequestTypeList[2]];
        // 如果是老门户的话 没有消费门槛选项
        if (this.isNewEmp === 1) {
          this.applyList = [RequestTypeList[0], RequestTypeList[6], RequestTypeList[2]];
        }
        // 导购分销
      } else if (this.policyType === PolicyType.guider) {
        this.applyList = RequestTypeList.slice(4, 5);
      } else {
        this.applyList = RequestTypeList.slice(5, 6);
      }
      if (!this.applyList.find(v => v.label === this.data.requestConfig.requestType)) {
        this.data.requestConfig.requestType = this.applyList[0].label;
      }
    });
  }

  getSpecialProList() {
    IPSService.proCommPolicyList({
      postParams: {
        policyId: this.policyId,
        page: 1,
        pageSize: 10,
        keyword: '',
        sgId: this.sgId,
      },
    }).then((response) => {
      this.specialProductConfig = response.count;
    });
  }

  getPageInfo(pageId) {
    return IPSService.miniPageInfo({
      postParams: {
        pageId,
      },
    }).then((response) => {
      return response.pageName;
    });
  }

  async getPageName(pageId, key) {
    this.data[key] = await this.getPageInfo(pageId);
  }

  otherConfigValidate(rule, value, callback) {
    if (value.uploadIDCard && (!value.watermarkText || !value.watermarkText.trim())) {
      callback(new Error(' '));
      // } else if (!value.uploadIDCard && !value.needReason && !value.needAddress && !value.needReview) {
      //   callback(new Error("请选择其他条件"));
    } else {
      callback();
    }
  }

  selectMiniLink(key: string) {
    if (this.disabled) {
      return;
    }
    miniPageLink.open({ sgId: Number(this.sgId) }).then((result) => {
      this.data[key] = result.id;
      this.data[`${key}Name`] = result.name;
      this.$refs.form.validateField(key, noop);
    }, noop);
  }

  changeBuyerLevel(val) {
    if (val) {
      console.log(val);
    } else {
      this.rules['requestConfig.allowLevel'] = [{ required: true, message: '请选择会员等级', trigger: ['blur', 'change'] }];
      // this.$refs.form.validateField()
    }
  }

  addProfitConfig(i) {
    this.data.commissionConfig.list.push({
      maxPercent: 100,
      minPercent: 30,
      distributionPercent: 0.01,
    });
  }

  removeProfitConfig(i) {
    this.data.commissionConfig.list.splice(i, 1);
  }

  addClass() {
    bindClassDialog
      .open({
        defaultCheckedKeys: this.data.commissionConfig.classConfig
          .map(v => v.classCode)
          .join(',')
          .split(','),
      })
      .then((result) => {
        this.data.commissionConfig.classConfig.push({
          classCode: result
            .filter(v => v.isLeafe)
            .map(val => val.value_no)
            .join(','),
          classPerCent: 5,
        });
      }, noop);
  }

  productProfitConfig() {
    specialProConfig.open({ empCode: this.empCode, policyId: this.policyId, sgId: this.sgId, title: '特殊商品佣金配置' }).then(
      (result) => {
        this.getSpecialProList();
      },
      () => {
        this.getSpecialProList();
      },
    );
  }

  removerOtherProfitConfig(index) {
    this.data.commissionConfig.classConfig.splice(index, 1);
  }

  removeLinkPage(key) {
    this.data[key] = '';
    this.data[`${key}Name`] = '';
    this.$refs.form.validateField(key, noop);
  }

  // 保存
  onSave() {
    this.$refs.form.validate((result) => {
      if (result) {
        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });
        const postParams = cloneDeep(this.data);
        postParams.otherConfig.needAddress = Number(postParams.otherConfig.needAddress);
        postParams.otherConfig.needReason = Number(postParams.otherConfig.needReason);
        postParams.otherConfig.uploadBankCard = Number(postParams.otherConfig.uploadBankCard);
        postParams.otherConfig.needReview = Number(postParams.otherConfig.needReview);
        postParams.otherConfig.uploadIDCard = Number(postParams.otherConfig.uploadIDCard);
        if (postParams.otherConfig.uploadBankCard === 0) {
          postParams.profitOutConfig.checkBankCard = 0;
        }
        this.data.isOpenSecond && (postParams.secondGuiderConfig.secondBalanceConfig.secondProportion *= 100);
        Object.assign({}, postParams, { policyState: 1, configType: 1 }, { sgId: this.sgId });
        IPSService.newDistributionIndoEdit({
          postParams,
        }).then(
          (result) => {
            this.$message.success('保存成功');
            loading.close();
            this.goBack();
          },
          () => {
            loading.close();
          },
        );
      } else {
        this.$nextTick(() => {
          if (this.$el.querySelector('.el-form-item__error')) {
            this.$el.querySelector('.el-form-item__error').scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  }

  /**
   * 暂存
   * @returns null
   */
  tempSave() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    const postParams = cloneDeep(this.data);
    postParams.otherConfig.needAddress = Number(postParams.otherConfig.needAddress);
    postParams.otherConfig.needReason = Number(postParams.otherConfig.needReason);
    postParams.otherConfig.uploadBankCard = Number(postParams.otherConfig.uploadBankCard);
    postParams.otherConfig.needReview = Number(postParams.otherConfig.needReview);
    postParams.otherConfig.uploadIDCard = Number(postParams.otherConfig.uploadIDCard);
    this.data.isOpenSecond && (postParams.secondGuiderConfig.secondBalanceConfig.secondProportion *= 100);
    if (postParams.otherConfig.uploadBankCard === 0) {
      postParams.profitOutConfig.checkBankCard = 0;
    }
    Object.assign({}, postParams, { policyState: 2, configType: 2 }, { sgId: this.sgId });
    IPSService.newDistributionIndoEdit({
      postParams,
    }).then(
      (result) => {
        this.$message.success('暂存成功');
        loading.close();
      },
      () => {
        loading.close();
      },
    );
  }

  goBack() {
    this.$emit('goBack');
  }

  getClassList() { }

  uploadPosterSuccess(val) {
    this.data.secondGuiderConfig.sharePosterConfig.imageUrl = val.content;
  }

  uploadCardSuccess(val) {
    this.data.secondGuiderConfig.shareCardConfig.imageUrl = val.content;
  }

  render(h) {
    return (
      <div class="new-distribution-config formWrapper">
        <el-form props={{ model: this.data }} disabled={this.disabled} rules={this.rules} ref="form" label-position="left" class="distribution-edit-form" validate-on-rule-change={false} label-width="136px">
          <div class="blockTitle">基础信息</div>
          <el-form-item prop="policyName" label="策略名称">
            <el-input v-model={this.data.policyName} maxlength={20} show-word-limit class="wid-210" />
          </el-form-item>
          <el-form-item label="策略类型">
            <div>{PolicyTypeText[this.data.policyType] && PolicyTypeText[this.data.policyType].text}</div>
          </el-form-item>
          <el-form-item label="分佣模式">
            <span>{PolicyPatternText[this.data.policyPattern] && PolicyPatternText[this.data.policyPattern].text}</span>
            <el-tooltip effect="light" content={PolicyPatternText[this.data.policyPattern] && PolicyPatternText[this.data.policyPattern].info} placement="top">
              <i class="iconfont iconzhushi font-size-14 r-ml-8"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item prop="tagName" label="角色标签">
            <el-input v-model={this.data.tagName} maxlength={6} show-word-limit class="wid-81" />
            <div class="tip">
              <span class="redText">*&nbsp;</span>
              角色标签用于标识适用于当前分销策略的分销员角色身份，如“直营导购”、“合作网红”等；
            </div>
          </el-form-item>
          <div class="blockTitle">申请门槛</div>
          <div class="tip block-title-tip">
            <span class="redText">*&nbsp;</span>
            用户成为会员后,需符合一定条件,方能获得分销资格。
          </div>
          <el-form-item prop="requestConfig.requestType" label="申请前提">
            <el-radio-group v-model={this.data.requestConfig.requestType}>
              {this.applyList.map((v, i) => {
                return [
                  <el-radio label={v.label} key={`${i}radio`} class={v.info ? 'request-type-info' : ''}>
                    {v.text}
                  </el-radio>,
                  v.info && (
                    <el-tooltip effect="light" content={v.info} placement="top" key={`${i}tip`}>
                      <i class="iconfont iconzhushi font-size-14 r-mr-24"></i>
                    </el-tooltip>
                  ),
                ];
              })}
            </el-radio-group>
          </el-form-item>
          <div class="request-type">
            {this.data.requestConfig.requestType === RequestType.DEPOSIT && (
              <el-form-item label="" prop="requestConfig.deposit">
                <span class="r-pr-12">需缴纳押金</span>
                <el-input-number controls={false} precision={2} min={0.01} max={999999} v-model={this.data.requestConfig.deposit} style="width: 94px" />
                <span class="padding-lr-8">元</span>
              </el-form-item>
            )}
            {this.data.requestConfig.requestType === RequestType.FULL_AMOUNT && (
              <el-form-item label="" prop="requestConfig.consumeDay">
                <el-input-number controls={false} precision={0} min={1} max={999999} v-model={this.data.requestConfig.consumeDay} style="width: 94px" />
                <span class="padding-lr-8">天内在本店线上及线下累计消费金额达</span>
              </el-form-item>
            )}
            {this.data.requestConfig.requestType === RequestType.FULL_AMOUNT && (
              <el-form-item label="" prop="requestConfig.money">
                <el-input-number controls={false} precision={2} min={0.01} max={999999} v-model={this.data.requestConfig.money} style="width: 94px" />
                <span class="padding-lr-8">元</span>
              </el-form-item>
            )}
            {/* {this.data.requestConfig.requestType === RequestType.FULL_AMOUNT && (
              <p>
                <el-checkbox v-model={this.data.requestConfig.linkNoLimit} true-label={1} false-label={0} class="text-black">
                  通过二级分销邀请连接申请时，不受申请前提限制
                </el-checkbox>
              </p>
            )} */}
            {this.data.requestConfig.requestType === RequestType.BUYER_LEVEL && (
              <el-form-item label="" prop="requestConfig.allowLevel">
                <el-checkbox-group v-model={this.data.requestConfig.allowLevel} onChange={val => this.changeBuyerLevel(val)}>
                  {this.buyerLevel.map((v, i) => {
                    return (
                      <el-checkbox label={v.cstLevelCode} key={`${i}check`}>
                        {v.cstLevelName}
                      </el-checkbox>
                    );
                  })}
                </el-checkbox-group>
                {/* <p>
                  <el-checkbox v-model={this.data.requestConfig.linkNoLimit} true-label={1} false-label={0} class="text-black">
                    通过二级分销邀请连接申请时，不受申请前提限制
                  </el-checkbox>
                </p> */}
              </el-form-item>
            )}
            {/* {this.data.requestConfig.requestType === RequestType.FULL_AMOUNT && (
              <el-form-item label="" prop="requestConfig.returnDay">
                <el-input-number
                  controls={false}
                  precision={0}
                  min={1}
                  max={999999}
                  v-model={this.data.requestConfig.returnDay}
                  style="width: 94px"
                />
                <span class="padding-lr-8">天内无退货退款</span>
              </el-form-item>
            )} */}
          </div>
          <el-form-item prop="otherConfig" label="其他条件" class="r-mb-12">
            <div>
              <el-checkbox class="other-config-checkbox" v-model={this.data.otherConfig.uploadIDCard} true-label={1} false-label={0} onChange={val => !val && (this.data.otherConfig.watermarkText = '')}>
                需上传身份证
              </el-checkbox>
              {!!this.data.otherConfig.uploadIDCard && (
                <span>
                  <span class="r-pr-12 r-ml-12">身份证水印文本</span>
                  <el-input v-model={this.data.otherConfig.watermarkText} maxlength={10} show-word-limit class="wid-125" />
                </span>
              )}
            </div>
            <el-checkbox class="other-config-checkbox" v-model={this.data.otherConfig.needReason} true-label={1} false-label={0}>
              需填写申请理由
            </el-checkbox>
            <el-checkbox class="other-config-checkbox" v-model={this.data.otherConfig.needAddress} true-label={1} false-label={0}>
              需填写地址
            </el-checkbox>
            {this.policyPattern === PolicyPattern.commission && this.isShowNeedBank && <el-checkbox class="other-config-checkbox" v-model={this.data.otherConfig.uploadBankCard} true-label={1} false-label={0}>
              需填写银行卡信息
            </el-checkbox>}
            <br />
            <el-checkbox class="other-config-checkbox" v-model={this.data.otherConfig.needReview} true-label={1} false-label={0}>
              需后台管理员审核身份
            </el-checkbox>
          </el-form-item>
          <el-form-item prop="rulePage" label="规则介绍">
            <span class={['scopeSpan', this.disabled && 'disabled']} onClick={this.selectMiniLink.bind(this, 'rulePage')}>
              请选择
            </span>
            {!!this.data.rulePage && (
              <p class="link-page-name">
                [{this.data.rulePage}]{this.data.rulePageName}
                {!this.disabled && <i class="iconfont iconchahao" onClick={this.removeLinkPage.bind(this, 'rulePage')} />}
              </p>
            )}
            <div class="tip">
              <span class="redText">*&nbsp;</span>
              在用户申请加入分销员时,弹出该规则介绍,以向申请者介绍相关规则。请在微页面中提前配置好。
            </div>
          </el-form-item>
          <el-form-item prop="rulePage" label="申请页提示信息">
            <el-input v-model={this.data.requestConfig.tips} class="wid-250" maxlength="30" show-word-limit />
            <div class="tip line-height-24">
              <span class="redText">*&nbsp;</span>
              如填写，将展示在申请页顶部。
            </div>
          </el-form-item>

          <div class="blockTitle">分销及佣金规则</div>
          <div class="tip block-title-tip">
            <span class="redText">*&nbsp;</span>
            请设置当前策略的佣金规则,如商品未设置独立规则,则按此规则计算佣金。
          </div>
          {this.policyPattern === PolicyPattern.achievement && (
            <el-form-item prop="" label="分销佣金比例">
              <el-radio-group v-model={this.data.commissionConfig.type}>
                <el-radio label={2}>与线下业绩体系同规则,佣金体现在工资中</el-radio>
              </el-radio-group>
            </el-form-item>
          )}
          {this.policyPattern === PolicyPattern.commission && [
            <el-form-item prop="" label="分销佣金比例">
              <el-radio-group v-model={this.data.commissionConfig.type}>
                <el-radio label={1}>按商品折数设置比例</el-radio>
                {/* <el-radio label={2}>按商品分类设置比例</el-radio> */}
              </el-radio-group>
            </el-form-item>,
            <div class="commission-config">
              {this.data.commissionConfig.list.map((val, i) => {
                const funcKey = i ? 'removeProfitConfig' : 'addProfitConfig';
                return [
                  <div key={`${i}commission-config`}>
                    <i class={[i ? 'el-icon-remove' : 'el-icon-circle-plus', 'profit-icon']} onClick={this[funcKey].bind(this, i)} />
                    <el-form-item prop={`commissionConfig.list[${i}].minPercent`} rules={{ required: true, message: ' ', trigger: ['blur', 'change'] }}>
                      {/* 杭俊雅说可以为0 */}
                      <el-input-number controls={false} precision={2} min={0} max={100} v-model={this.data.commissionConfig.list[i].minPercent} style="width: 80px" /> %<span class="r-pl-12">&lt;&nbsp;&nbsp;&nbsp;商品折数</span>
                      <span class="r-px-12">&lt;=</span>
                    </el-form-item>
                    <el-form-item prop={`commissionConfig.list[${i}].maxPercent`} rules={{ required: true, message: ' ', trigger: ['blur', 'change'] }}>
                      {/* 杭俊雅说可以为0 */}
                      <el-input-number controls={false} precision={2} min={0} v-model={this.data.commissionConfig.list[i].maxPercent} style="width: 80px" />
                      <span class="padding-lr-8">%</span>
                      <span class="padding-lr-8 padding-left-12">分销佣金比例为</span>
                    </el-form-item>
                    <el-form-item prop={`commissionConfig.list[${i}].distributionPercent`} rules={{ required: true, message: ' ', trigger: ['blur', 'change'] }}>
                      {/* 杭俊雅说可以为0 */}
                      <el-input-number controls={false} precision={2} min={0} max={this.maxCommission} v-model={this.data.commissionConfig.list[i].distributionPercent} style="width: 80px" />
                      <span class="padding-lr-8">%</span>
                    </el-form-item>
                  </div>,
                ];
              })}
              <div class="tip r-pb-12">
                <p>说明</p>
                <p>1)商品折数=商品结算金额/商品原价*100%,所填写的商品折数需覆盖0%~100%</p>
                <p>2)给付的分销佣金=订单商品的结算金额*分销佣金比例</p>
                <p>3)商品折数=商品结算价/商品牌价</p>
              </div>
            </div>,
            <el-form-item prop="" label="特殊商品佣金配置">
              <el-input value={`已配置${this.specialProductConfig}件`} disabled class="wid-60" />{' '}
              <el-button type="primary" onClick={this.productProfitConfig.bind(this)}>
                配置
              </el-button>
              <div class="tip">
                <span class="redText">*&nbsp;</span>特殊商品佣金配置优先级{'>'}分销佣金比例优先级
              </div>
            </el-form-item>,
            <el-form-item prop="commissionConfig.countTime" label="佣金结算周期">
              <el-select v-model={this.data.commissionConfig.countType} class="wid-47">
                {SettlementCycle.map((v, i) => {
                  return <el-option label={`${v.label}后`} value={v.value} key={i} />;
                })}
              </el-select>
              <span class="padding-lr-8"></span>
              <el-input-number controls={false} precision={0} min={0} max={99} v-model={this.data.commissionConfig.countTime} class="wid-47" />
              <span class="r-pl-12">天</span>
              <div class="tip">
                <span class="redText">*&nbsp;</span>
                <span class="text-red" style="font-size: 15px;">
                  {SettlementCycle.find(v => v.value === this.data.commissionConfig.countType).label}
                </span>
                后第{this.data.commissionConfig.countTime}
                天计算佣金给分销员,如结算前发生退款退货,则待到账佣金失效;
              </div>
            </el-form-item>,
            <el-form-item prop="commissionConfig.tips" label="佣金页提示信息">
              <el-input v-model={this.data.commissionConfig.tips} class="wid-250" maxlength="30" show-word-limit />
              <div class="tip line-height-24">
                <span class="redText">*&nbsp;</span>
                如填写，将展示在佣金页
              </div>
            </el-form-item>,
          ]}
          {this.policyPattern === PolicyPattern.commission && [
            <div class="blockTitle">提现及打款规则</div>,
            <div class="tip block-title-tip">
              <span class="redText">*&nbsp;</span>
              佣金抵达分销员账户后,需用户主动提现并经过管理员审核后,方可将佣金从账户转出。
            </div>,
            <el-form-item prop="profitOutConfig.limitBalance" label="起提额度">
              <el-input-number controls={false} precision={2} min={1} max={5000} v-model={this.data.profitOutConfig.limitBalance} style="width: 94px" />
              <span class="padding-lr-8">元</span>
              <span class="tip r-ml-48">
                <span class="redText">*&nbsp;</span>账户余额达到起提额度方可发起提现
              </span>
            </el-form-item>,
            <el-form-item prop="profitOutConfig.timeConfig.outCount" label="提现频次">
              每&nbsp;&nbsp;
              <el-select v-model={this.data.profitOutConfig.timeConfig.type} class="wid-52">
                <el-option label={'日'} value={1} />
                <el-option label={'周'} value={2} />
                <el-option label={'月'} value={3} />
              </el-select>
              <span class="padding-lr-8">最多提现</span>
              <el-input-number v-model={this.data.profitOutConfig.timeConfig.outCount} controls={false} precision={0} min={1} max={99} class="wid-47" />
              <span class="padding-lr-8">次</span>
            </el-form-item>,
            <el-form-item prop="profitOutConfig.maxBalance" label="单次提现最大额度">
              <el-input-number v-model={this.data.profitOutConfig.maxBalance} controls={false} precision={2} min={1} max={20000} class="wid-47" />
              <span class="padding-lr-8">元</span>
            </el-form-item>]}
          {!!this.data.otherConfig.uploadBankCard && this.policyPattern === PolicyPattern.commission && [<el-form-item prop="" label="银行卡信息">
            <el-checkbox class="other-config-checkbox" v-model={this.data.profitOutConfig.checkBankCard} true-label={1} false-label={0}>
              提现前检查银行卡信息是否存在
            </el-checkbox>
            <span class="tip"><span class="text-red r-ml-48 r-mr-4">*</span> 银行卡信息如不存在，则提示进入银行卡信息维护画面。</span>
            {/* <el-input type="textarea" v-model={this.data.profitOutConfig.backcardInfo} maxlength={300} autosize={{ minRows: 8 }} show-word-limit class="wid-300" /> */}
          </el-form-item>]}
          {this.policyPattern === PolicyPattern.commission && <el-form-item prop={this.data.profitOutConfig.outType?'profitOutConfig.outNote':'profitOutConfig.outTitle'} label="提现协议">
            <p><el-radio-group v-model={this.data.profitOutConfig.outType}>
              <el-radio label={1}>直接录入</el-radio>
              <el-radio label={2}>图文消息链接</el-radio>
            </el-radio-group></p>
            {this.data.profitOutConfig.outType == 1 && [<el-input type="textarea" v-model={this.data.profitOutConfig.outNote} maxlength={2000} autosize={{ minRows: 8 }} show-word-limit class="wid-300" />, <p class="tip"><span class="redText">*</span> 提现说明将体现在提现画面，以弹窗方式展现。</p>]}
            {this.data.profitOutConfig.outType == 2 && [
              <el-form-item class="r-ml-0" label="协议名称" prop="profitOutConfig.outTitle">
                <el-input v-model={this.data.profitOutConfig.outTitle} class="wid-240" /></el-form-item>,
              <el-form-item class="r-ml-0" label="图文消息链接" prop="profitOutConfig.outNote">
                <el-input v-model={this.data.profitOutConfig.outNote} class="wid-240" />
                <p class="tip"><span class="redText">*</span> 仅可填入与当前小程序绑定的公众号图文消息链接。</p>
              </el-form-item>

            ]}
          </el-form-item>}
          {this.policyPattern === 1 && [
            <div class="blockTitle">二级分销设置</div>,
            <div class="tip block-title-tip">
              <span class="redText">*&nbsp;</span>请设置二级分销的佣金比例及线下人数
            </div>,
            <el-checkbox v-model={this.data.isOpenSecond} true-label={1} false-label={0}>
              启用二级分销
            </el-checkbox>,
          ]}
          {!!this.data.isOpenSecond
            && this.policyPattern === 1 && [
              <el-form-item prop="secondGuiderConfig.secondMaxPerson" label="下限人数限制">
                <el-input-number v-model={this.data.secondGuiderConfig.secondMaxPerson} controls={false} max={9999} precision={0} min={1} class="wid-50" /> &nbsp;人
              </el-form-item>,
              <el-form-item prop="secondGuiderConfig.secondBalanceConfig.secondProportion" label="二级分销佣金比例">
                <el-select v-model={this.data.secondGuiderConfig.secondBalanceConfig.type} class="wid-70 r-mr-6">
                  <el-option label={'商品结算金额'} value={2} />
                  <el-option label={'一级分销佣金'} value={1} />
                </el-select>的
                <el-input-number v-model={this.data.secondGuiderConfig.secondBalanceConfig.secondProportion} controls={false} max={100} precision={0} min={0.01} class="wid-50 r-ml-6" /> &nbsp;%
                <span class="tip r-ml-48">
                  <span class="redText">*&nbsp;</span>
                  {this.data.secondGuiderConfig.secondBalanceConfig.type === 1 ? '【一级分销佣金】：给付上级分销佣金=订单商品的结算金额*一级分销佣金比例*二级分销佣金比例' : '【商品结算金额】：给付上级分销佣金=订单商品的结算金额*二级分销佣金比例'}
                </span>
              </el-form-item>,
              <el-form-item prop="" label="二级有效期">
                <el-input-number v-model={this.data.secondGuiderConfig.secondValidityPeriodDay} controls={false} max={9999} precision={0} min={1} class="wid-50" /> &nbsp;天
                <span class="tip r-ml-48">
                  <span class="redText">*&nbsp;</span>
                  分销员介绍发展的下级分销员，在此有效期内的分销销售，介绍者可获得额外的二级分销佣金，最大值为1000天
                </span>
              </el-form-item>,
              <el-form-item prop="" label="分享海报配置">
                <div class="share-config">
                  <div>
                    <Upload onImgUploadSuccess={val => this.uploadPosterSuccess(val)} img={this.data.secondGuiderConfig.sharePosterConfig.imageUrl} noDelete={false} maxSize={2048} disabled={this.disabled} />
                  </div>
                  <div class="share-content">
                    <el-row>
                      <el-col span={4}>海报标题</el-col>
                      <el-col span={12}>
                        <el-input v-model={this.data.secondGuiderConfig.sharePosterConfig.title} />
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col span={4}>海报描述</el-col>
                      <el-col span={12}>
                        <el-input type="textarea" v-model={this.data.secondGuiderConfig.sharePosterConfig.desc} autosize={{ minRows: 4, maxRows: 6 }} rows={8} resize="none" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="tip line-height-18">注1：建议图片分辨率为500*500px；</div>
                <div class="tip line-height-18">注2：图片大小不超过2M，支持jpg、jpeg、gif、png格式</div>
              </el-form-item>,
              <el-form-item prop="" label="分享卡片设置">
                <div class="share-config">
                  <div>
                    <Upload onImgUploadSuccess={val => this.uploadCardSuccess(val)} img={this.data.secondGuiderConfig.shareCardConfig.imageUrl} noDelete={false} maxSize={2048} disabled={this.disabled} />
                  </div>
                  <div class="share-content">
                    <el-row>
                      <el-col span={4}>卡片标题</el-col>
                      <el-col span={12}>
                        <el-input v-model={this.data.secondGuiderConfig.shareCardConfig.title} />
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="tip line-height-18">注1：建议图片分辨率为800*640px；</div>
                <div class="tip line-height-18">注2：图片大小不超过2M，支持jpg、jpeg、gif、png格式</div>
              </el-form-item>,
            ]}
        </el-form>
        <div class="bottomWrapper">
          {!this.disabled && (
            <el-button type="primary" onClick={this.onSave.bind(this)}>
              保存
            </el-button>
          )}{' '}
          {this.policyState == 2 && !this.disabled && (
            <span class="scopeSpan line-height-32" onClick={this.tempSave.bind(this)}>
              暂存
            </span>
          )}
          <span class="scopeSpan line-height-32" onClick={this.goBack.bind(this)}>
            返回
          </span>
        </div>
      </div>
    );
  }
}
